import { OfficeFolders, Offices, Status } from "../Components/index.js";

export default [
    {
        path: "/reports/letter/office",
        component: Offices,
        name: "report.letter.office",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/reports/letter/office-status",
        component: Status,
        name: "report.letter.office.status",
        meta: {
            requiresAuth: true,
        },
    },
];
